export const enterprisePage = {
	hero: {
		title: 'Enterprise-scale **quest management**',
		description:
			'Join 35,061 customers who use our link management infrastructure to take their marketing efforts to the next level.',
		titleGradient: 'blue',
	},
};
